module.exports = __webpack_public_path__ + "img/address.a029fc48.png";